/*
 * @Date: 2025-04-01 17:52:01
 * @Description:个税预扣税款明细
 */
import TaxWithholding from '../views/tax-withholding.vue';

export const route = [
  {
    path: '/main/asp/tax-withholding',
    name: 'asp-tax-withholding',
    meta: {
      title: '个税预扣税款明细'
    },
    component: TaxWithholding
  }
];
